import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const RestaurantMenuIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"restaurant_menu"} ref={ref}/>
});

RestaurantMenuIcon.displayName = "RestaurantMenuIcon";
